import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Healthcare/Hero";
import IndustriesContent from "../components/Healthcare/IndustriesContent";
import PageTitle from "../components/Healthcare/PageTitle";

import '../assets/Webdevelopment.css';



const Healthcare = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  	</div>
	)
}

export default Healthcare;
